module.exports = __webpack_public_path__ + "img/統計学入門_2_1_問題.28a16fe6.png";